/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationHierarchy } from './OrganizationHierarchy';
import {
    OrganizationHierarchyFromJSON,
    OrganizationHierarchyFromJSONTyped,
    OrganizationHierarchyToJSON,
    OrganizationHierarchyToJSONTyped,
} from './OrganizationHierarchy';

/**
 * 
 * @export
 * @interface GetMeOrgsResp
 */
export interface GetMeOrgsResp {
    /**
     * 
     * @type {Array<OrganizationHierarchy>}
     * @memberof GetMeOrgsResp
     */
    org_hierarchy: Array<OrganizationHierarchy>;
}

/**
 * Check if a given object implements the GetMeOrgsResp interface.
 */
export function instanceOfGetMeOrgsResp(value: object): value is GetMeOrgsResp {
    if (!('org_hierarchy' in value) || value['org_hierarchy'] === undefined) return false;
    return true;
}

export function GetMeOrgsRespFromJSON(json: any): GetMeOrgsResp {
    return GetMeOrgsRespFromJSONTyped(json, false);
}

export function GetMeOrgsRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMeOrgsResp {
    if (json == null) {
        return json;
    }
    return {
        
        'org_hierarchy': ((json['org_hierarchy'] as Array<any>).map(OrganizationHierarchyFromJSON)),
    };
}

export function GetMeOrgsRespToJSON(json: any): GetMeOrgsResp {
    return GetMeOrgsRespToJSONTyped(json, false);
}

export function GetMeOrgsRespToJSONTyped(value?: GetMeOrgsResp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_hierarchy': ((value['org_hierarchy'] as Array<any>).map(OrganizationHierarchyToJSON)),
    };
}

